<template>
  <v-card>
    <v-card-title>
      <span class="font-weight-semibold">{{ title }}</span>
    </v-card-title>

    <v-card-subtitle class="mt-n5" v-if="subtitle">
      <span class="font-weight-semibold text--primary me-1"
        >{{ subtitle }}
      </span>
    </v-card-subtitle>

    <v-card-text>
      <v-row>
        <v-col
          v-for="item in data"
          :key="item.title"
          cols="6"
          md="3"
          class="d-flex align-center"
        >
          <v-avatar :color="`${item.color} lighten-5`" rounded size="62">
            <v-icon dark :color="`${item.color} darken-3`" large>
              {{ item.icon }}
            </v-icon>
          </v-avatar>
          <div class="ms-3">
            <div class="text-subtitle-2 mb-0">
              {{ item.title }}
            </div>
            <h3 class="text-h6 font-weight-semibold">
              {{ item.value }}
              <span class="text-caption">({{ item.percentage }}%)</span>
            </h3>
          </div>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "statistics-multi-card",
  props: {
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      required: false,
    },
    data: {
      type: Array,
      required: true,
    },
  },
};
</script>
